<template>
  <div>
    <BaseCleanPopup
      v-body
      @close="closeExplorer"
      ref="popup"
      :h="40"
      :w="300"
      :winh="446"
      :winw="317"
      v-zindex
    >
      <template v-slot:header>
        <div class="title">
          {{ $t("general.select") }}
          {{ showfiles ? $t("files1.file") : $t("files1.place") }}
        </div>
      </template>
      <div class="absolute h-100 w-100 text-a-center" v-remove.offline>
        <h1 class="unauthorized">{{ $t("general.notAllow") }}</h1>
      </div>
      <div v-remove.online class="h-100">
        <div
          class="outer-list flex-align-center"
          style="height: calc(100% - 90px)"
        >
          <div class="content h-100">
            <div
              class="header dir-rtl rtl flex padd-6 border-b-light padd-l-12"
            >
              <div
                @click="loadHome"
                class="home icon-item rtl icon-otzar otz-icon-square otz-icon border-l-light"
              >
                o
              </div>
              <div
                class="back icon-otzar otz-icon-square otz-icon"
                v-tooltip="{
                  content: $t('general.back'),
                }"
                style="transform: rotate(90deg);"
                @click="goUp"
              >
                2
              </div>
              <div dir="ltr" class="flex-g-1 mrg-r-6">
                <input
                  type="text"
                  class="w-100 padd-3"
                  disabled
                  :value="curPath"
                />
              </div>
            </div>
            <contentExplore
              @open="openFold"
              @select="selectFold"
              :list="folders"
              :files="files"
              :showfiles="showfiles"
              :active="active"
            />
          </div>
        </div>

        <div
          class="dir-rtl rtl border-t-light flex flex-align-center padd-6 padd-l-12"
        >
          {{ showfiles ? $t("files1.selectFile") : $t("files1.selectFolder") }}:
          &nbsp;
          <input
            style="direction: ltr"
            class="flex-g-1"
            disabled
            type="text"
            :value="
              this.active.dir
                ? calcPath(this.active)
                : showfiles
                ? noSelectedFile
                : noSelectedFolder
            "
          />
        </div>
        <div class="footer border-t-light padd-12">
          <div class="flex-g-1 rtl flex-center">
            <div class="flex-center ">
              <BaseButton @click="selectAndClose">{{
                $t("general.select")
              }}</BaseButton>
            </div>
            <div class="flex-center">
              <BaseButton @click="closeExplorer">{{
                $t("general.cancel")
              }}</BaseButton>
            </div>
          </div>
        </div>
      </div>
    </BaseCleanPopup>
  </div>
</template>

<script>
import config from "@/config/general.js";
import * as explorer from "@/services/offline/folderExplorer.js";
import contentExplore from "@/components/BaseComponents/explorer/contentExplore.vue";
export default {
  props: {
    showfiles: { type: Boolean, default: false },
    openAt: { type: String, default: null },
  },
  data() {
    return {
      folders: [],
      files: [],
      curFolder: {},
      home: "",
      active: {},
      noSelectedFile: this.$t("folders.notSelectedFile"),
      noSelectedFolder: this.$t("folders.notSelectedFolder"),
    };
  },
  components: {
    contentExplore,
  },
  async created() {
    if (this.online) return;
    let home = await explorer.getHomePath();
    this.home = home;
    this.loadFolders(this.openAt || this.home);
  },
  methods: {
    closeExplorer() {
      this.$emit("close");
    },
    openFold(folder) {
      if (folder.type != "file") this.enterToFolder(folder);
      else {
        this.$emit("selected", this.calcPath(this.active));
      }
    },
    calcPath(item) {
      let path = item.type == "drive" ? item.dir : item.dir + "\\" + item.name;
      path = path.replace(/\//g, "\\").replace(/\\\\/g, "\\");
      return path;
    },
    selectFold(folder) {
      this.active = folder;
    },
    selectAndClose() {
      this.$emit("selected", this.calcPath(this.active));
    },
    loadHome() {
      this.loadFolders(this.home);
    },
    async loadDrives() {
      let drives = await explorer.getDrives();

      this.folders = drives;
      this.files = [];
      this.curFolder = { type: "root", name: "", dir: "" };
    },
    async loadFolders(path) {
      let folders = await explorer.getSubFolders(path);
      this.folders = folders.folders;

      this.files = folders.files;
      this.curFolder = {
        name: folders.name,
        type: folders.type,
        dir: folders.dir,
      };
    },
    enterToFolder(folder) {
      // if (folder.type === "drive") return this.loadFolders(folder.dir);
      this.loadFolders(this.calcPath(folder));
    },
    goUp() {
      if (this.curFolder.type === "drive") return this.loadDrives();
      if (this.curFolder.type === "root") return this.loadDrives();
      this.loadFolders(this.curFolder.dir);
    },
  },
  computed: {
    curPath() {
      if (this.curFolder.type == undefined) return "";
      if (this.curFolder.type === "root") return this.$t("general.myComputer");
      let path = this.calcPath(this.curFolder);
      return path;
      // return path.replace(/\//g, "\\").replace(/\\\\/g, "\\");
    },
    online() {
      return config.serverConnection === "online";
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  align-items: center;
  height: 100%;
}
.unauthorized {
  margin: auto 0;
  position: absolute;
  width: 100%;
  top: 50%;
  transform: translateY(-50%);
  font-size: 17px;
  font-weight: 500;
  color: #808080;
}
.header {
  .home,
  .back {
    height: 33px;
    width: 33px;
    line-height: 33px;
    color: #000;
    border-radius: 0;
    display: block;
    margin: 0;
  }
}
</style>
